// Canvas2D port of upstream TOPOLOGY by Kjetil Midtgarden Golid.
// Particles follow gradients of a seeded noise field and accumulate contour trails.
import CanvasBase from "./_canvasBase.js";
import { noise3D } from "./noise.js";
import { color2Rgb } from "./helpers.js";
export default class Topology extends CanvasBase {
  onInit() {
    this.noise = noise3D(this.options.seed);
    this.positions = Float32Array.from(
      { length: this.options.count * 2 },
      (_, i) => this.random() * (i % 2 ? this.height : this.width),
    );
    this.lastT = undefined;
    this.fresh = true;
  }
  onResize() {
    this.fresh = true;
  }
  onMouseMove(x, y) {
    this.mx = x * this.width;
    this.my = y * this.height;
  }
  onUpdate() {
    const fresh = this.fresh;
    if (fresh) {
      this.clear();
      this.fresh = false;
    }
    const dt =
      fresh || this.lastT === undefined ? 1 : Math.min(3, this.t - this.lastT);
    this.lastT = this.t;
    if (dt <= 0) return;
    for (let step = 0; step < (fresh ? 40 : 1); step++) this.drawStep(dt);
  }
  onOptionsChange() {
    this.fresh = true;
  }
  drawStep(dt) {
    const c = this.context,
      o = this.options;
    c.strokeStyle = color2Rgb(o.color, 0.18);
    c.lineWidth = 0.8;
    c.beginPath();
    for (let i = 0; i < this.positions.length; i += 2) {
      let x = this.positions[i],
        y = this.positions[i + 1];
      const u = x * 0.003,
        v = y * 0.003;
      const dx = this.noise(u + 0.04, v) - this.noise(u - 0.04, v),
        dy = this.noise(u, v + 0.04) - this.noise(u, v - 0.04);
      const a = Math.atan2(dy, dx) + Math.PI / 2;
      const d = Math.hypot(x - this.mx, y - this.my),
        react = Math.exp(-d / 90) * o.interactionStrength;
      const nx =
          x +
          (Math.cos(a) * 2.2 + (x - this.mx) * 0.01 * react) * dt * o.intensity,
        ny =
          y +
          (Math.sin(a) * 2.2 + (y - this.my) * 0.01 * react) * dt * o.intensity;
      c.moveTo(x, y);
      c.lineTo(nx, ny);
      this.positions[i] = (nx + this.width) % this.width;
      this.positions[i + 1] = (ny + this.height) % this.height;
    }
    c.stroke();
  }
}
Topology.prototype.defaultOptions = {
  color: 0x89964e,
  backgroundColor: 0x002222,
  count: 1800,
};
